import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { IfAgentHasRole } from 'components/shared/agentRole';
import itemStyles from './numberTableItem.module.scss';
const NumberTableFlowsDropdown = ({ onEdit, onRename, onDuplicate, onAudit, onMove, onRemove, isActive, }) => {
    const onToggleMenu = useCallback((isOpen) => {
        if (isOpen) {
            analytics.phoneFlowOptionsMenuOptionOpened();
        }
    }, []);
    const onEditClick = useCallback(() => {
        analytics.phoneFlowOptionsMenuOptionEditClicked();
        onEdit();
    }, [onEdit]);
    const onDuplicateClick = useCallback(() => {
        analytics.phoneFlowOptionsMenuOptionDuplicateClicked();
        onDuplicate();
    }, [onDuplicate]);
    const onRenameClick = useCallback(() => {
        analytics.phoneFlowOptionsMenuOptionRenameClicked();
        onRename();
    }, [onRename]);
    const onMoveToAnotherNumberClick = useCallback(() => {
        analytics.phoneFlowOptionsMenuOptionMoveToAnotherNumberClicked();
        onMove();
    }, [onMove]);
    const onAuditClick = useCallback(() => {
        analytics.phoneFlowOptionsMenuOptionAuditLogClicked();
        onAudit();
    }, [onAudit]);
    const onRemoveClick = useCallback(() => {
        analytics.phoneFlowOptionsMenuOptionDeleteClicked();
        onRemove();
    }, [onRemove]);
    return (_jsx(DropdownButton, { className: itemStyles.dropdown, icon: "dots-h", fixed: true, buttonProps: { variant: 'tertiary' }, onToggle: onToggleMenu, noArrow: true, dropdown: _jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: onEditClick }, { children: "Edit" })), _jsx(IfAgentHasRole, Object.assign({ role: 'admin' }, { children: _jsx(ButtonList.Item, Object.assign({ onClick: onDuplicateClick }, { children: "Duplicate" })) })), _jsx(ButtonList.Item, Object.assign({ onClick: onRenameClick }, { children: "Rename" })), _jsx(IfAgentHasRole, Object.assign({ role: 'admin' }, { children: _jsx(ButtonList.Item, Object.assign({ onClick: onMoveToAnotherNumberClick, isDisabled: isActive }, { children: "Move to another number" })) })), _jsx(ButtonList.Item, Object.assign({ onClick: onAuditClick }, { children: "See audit log" })), _jsxs(IfAgentHasRole, Object.assign({ role: 'admin' }, { children: [_jsx(ButtonList.Divider, {}), _jsx(ButtonList.Item, Object.assign({ onClick: onRemoveClick, isDisabled: isActive }, { children: "Delete" }))] }))] }) }));
};
export default NumberTableFlowsDropdown;
